// Texture key for a placement (callers still guard with textures.exists()). Furniture art never holds a character:
// sitting on a sofa / lying in a bed is the avatar's own pose (FurnitureSeats, sofas and beds 2026-10-29).
export function placementTexture(p) {
  if (p.type === 'furniture') return `furniture_${p.item}`;
  if (p.type === 'decoration') return `decoration_${p.item}`;
  return `buda_${p.item}`;
}
